import {useRive, Fit, useViewModelInstanceBoolean, useViewModelInstanceNumber} from 'rive-react';

export default function useRiveTriggers() {
  const {RiveComponent: ControlPanel, rive: controlPanelRive} = useRive({src: '/controlpanel.riv', stateMachines: 'controlPanel', autoplay: true, autoBind: true}, {fit: Fit.Fill});
  const {RiveComponent: LightDarkMode, rive: lightDarkModeRive} = useRive({src: '/lightdarkmode.riv', stateMachines: 'State Machine 1', autoplay: true, autoBind: true}, {fit: Fit.Fill});

  const controlVMI = controlPanelRive?.viewModelInstance;
  const lightDarkVMI = lightDarkModeRive?.viewModelInstance;

  const isLightMode = useViewModelInstanceBoolean('isLightMode', lightDarkVMI);
  const angleOfRotation = useViewModelInstanceNumber('joyStickPos', controlVMI);
  const isPaused = useViewModelInstanceBoolean('spinning', controlVMI);

  return {
    ControlPanel,
    LightDarkMode,
    isLightMode,
    angleOfRotation,
    isPaused,
    controlVMI,
    lightDarkVMI,
  };
}
